export class SummaryHelper {
  
  public static GetOptionLabelFromFieldByKeySummary = (field: Field, key: string) => {

    if(!field?.settings?.Options) {
      return "-";
    }

    var foundOption = field.settings.Options.split('\n').find((option) => {
      const [value, label] = option.split(';');
      return value == key;
    });
    return foundOption?.split(';')[1] ?? "-";
  }

  public static getAdresSummary = (prefix: string, formData: any, formFields: Field[]) => {
    const street = formData[prefix + "Straat"]?.value;
    const zipcode = formData[prefix + "Postcode"]?.value;
    const city = formData[prefix + "Woonplaats"]?.value ?? formData[prefix + "Plaats"]?.value;
    const housenumber = formData[prefix + "Huisnummer"]?.value;
    const housenumberAddition = formData[prefix + "Toevoeging"]?.value;

    const countryField = formFields.find((f) => f["@column"] == prefix + "Land");
    const countryValue = formData[prefix + "Land"]?.value;

    if(!street && !housenumber && !city) {
      return '-';
    }
    let address = '';

    if(street && housenumber) {
      address = address.concat(`${street} ${housenumber}`);

      if(housenumberAddition) {
        address = address.concat(` ${housenumberAddition ?? ""}`);
      }
      address = address.concat(`<br/>`);
    }
   
    if(zipcode) {
      address = address.concat(`${zipcode} `);
    }

    address = address.concat(`${city}<br/>`);

    if(countryField && countryValue) {
      address = address.concat(`${SummaryHelper.GetOptionLabelFromFieldByKeySummary(countryField, countryValue)}`);
    }

    return address;
  }
}